import { Component, OnInit } from '@angular/core';

import { ApContentModule, ApContentService } from '@ap/content';
import { ApIllustrationComponent } from '@ap/illustration';

import content from './footer.content.json';

/**
 * @ngdoc component
 * @name FooterComponent
 * @description Renders the footer component
 */
@Component({
    selector: 'ideal-footer',
    templateUrl: './footer.component.html',
    imports: [ApIllustrationComponent, ApContentModule]
})
export class FooterComponent implements OnInit {
    public constructor(private readonly contentService: ApContentService) {}

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
    }
}
